const SESSION_STORAGE_PREFIX = '[CONTENTS_DELIVERY]';

const getKey = (key: string) => `${SESSION_STORAGE_PREFIX}${key}`;

const parseJson = <T>(value: string | undefined | null, defaultValue?: T) => {
  try {
    return JSON.parse(value as string) as unknown as T;
  } catch (e) {
    console.error(e);

    return defaultValue;
  }
};

const isBrowser = typeof window !== 'undefined';

export const setItem = (key: string, value: Object | Array<any>) => {
  if (!isBrowser) {
    return;
  }

  return window.sessionStorage.setItem(getKey(key), JSON.stringify(value));
};

export const getItem = <T>(key: string) => {
  if (!isBrowser) {
    return;
  }

  return parseJson<T>(window.sessionStorage.getItem(getKey(key)));
};
